// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdArrowForward } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import * as userAction from '../../actions/users';
import * as closeableAction from '../../actions/closeable';
import PopupContent from '../PopupContent';
import PopupFooter from '../PopupFooter';
import Button from '../Button';
import styles from './createUsersTutorial.css';
import { Cancel } from '../CommonTexts';

type CreateUsersTutorialPropTypes = {
  className?: string,
  cancelUploadUsers: Function,
  updateCreateUsersStep: Function,
};

const CreateUsersTutorial = ({
  className,
  cancelUploadUsers,
  updateCreateUsersStep,
}: CreateUsersTutorialPropTypes) => (
  <Fragment>
    <PopupContent className={className}>
      <div className={styles.message}>
        { 'Para subir usuarios en masa deberás subir un archivo CSV con el siguiente formato, incluir los encabezados:' }
        {' '}
        <br />
        <br />
        { 'Posibles tipos:' }
        {' '}
        <b>
          { '(estudiante, monitor, chofer, padre)' }
        </b>
.
        {' '}
        <br />
        { 'Los únicos con contactos serán los estudiantes y tendrán los mismos datos que los demás ususarios.' }
        <br />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <tbody>
            <tr>
              <th>
                {i18n.t('labels.name', { count: 1 })}
              </th>
              <th>
                {i18n.t('labels.lastName', { count: 1 })}
              </th>
              <th>
                {i18n.t('labels.type')}
              </th>
              <th>
                {i18n.t('labels.phone')}
              </th>
              <th>
                {i18n.t('labels.email')}
              </th>
              <th>
                {'CÓDIGO'}
              </th>
            </tr>
            <tr>
              <td>
                {'Mario'}
              </td>
              <td>
                {'Subuyuj'}
              </td>
              <td>
                {'student'}
              </td>
              <td>
                {'42491097'}
              </td>
              <td>
                {'mario@edoo.io'}
              </td>
              <td>
                {'201804505'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </PopupContent>
    <PopupFooter size="large">
      <Button
        tint="gray"
        title={Cancel()}
        clearMargins
        isOutlined
        onClick={cancelUploadUsers}
      />
      <Button
        size="medium"
        title="Continuar"
        iconPosition="right"
        Icon={MdArrowForward}
        className={styles.approve}
        onClick={updateCreateUsersStep}
      />
    </PopupFooter>
  </Fragment>
);

export default connect(
  undefined,
  dispatch => ({
    cancelUploadUsers() {
      dispatch(closeableAction.close('uploadUsers'));
      dispatch(userAction.clearUploadingUsers());
    },
    updateCreateUsersStep() {
      dispatch(userAction.updateCreateUsersStep(2));
    },
  }),
)(CreateUsersTutorial);



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUsersTutorial/index.jsx